import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { Text, Box } from 'Components/Base';
import ArticleBoxStyles from 'Components/Classroom/Content/ArticleBoxStyles';
import HTMLView from 'Components/HTMLView';

import { EXAM_MODE } from '../../Exam/constant';

import BlockChoice from './QuestionType/BlockChoice';
import FillInTheBlank from './QuestionType/FillInTheBlank';

const QuestionWrapper = styled(Text)`
  ${ArticleBoxStyles}

  * {
    line-height: 1.75;
  }
  figure {
    margin: 0;
    img {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  a,
  a:visited {
    color: ${({ theme }) => theme.colors.primary};
  }

  pre {
    code {
      background: transparent;
      color: #657b83;
    }
  }
`;

const QuestionView = ({
  question,
  onAnswer,
  mode,
  isFillInTheBlankQuiz,
  renderFooterBlock,
  userAnswer,
  isCorrect,
  isShowSolution,
  t,
}) => {
  return (
    <Box px={40} py={32}>
      <Text textStyle={'caption'} pb={2} fontWeight={'normal'} fontFamily="content" color="hint">
        {t('EXAM.QUESTION')}
      </Text>
      {question.title && (
        <QuestionWrapper
          pb={isFillInTheBlankQuiz ? 7 : 4}
          lineHeight="loose"
          color="quizQuestionDetails"
          fontFamily="contentReadable"
        >
          <HTMLView rawContent={question.title} />
        </QuestionWrapper>
      )}
      {isFillInTheBlankQuiz ? (
        <FillInTheBlank
          isCorrect={isCorrect}
          question={question}
          onAnswer={onAnswer}
          mode={mode}
          userAnswer={userAnswer}
          renderFooterBlock={renderFooterBlock}
          isShowSolution={isShowSolution}
        />
      ) : (
        <BlockChoice
          onAnswer={onAnswer}
          choices={question.choices}
          questionId={question.id}
          type={question.type}
          mode={mode}
          isCorrect={question.isCorrect}
          isShowSolution={isShowSolution}
        />
      )}
    </Box>
  );
};

QuestionView.propTypes = {
  question: PropTypes.shape({
    choices: PropTypes.array,
    id: PropTypes.string,
  }).isRequired,
  onAnswer: PropTypes.func,
  mode: PropTypes.oneOf(Object.values(EXAM_MODE)),
  isFillInTheBlankQuiz: PropTypes.bool,
  isCorrect: PropTypes.bool,
  isShowSolution: PropTypes.bool,
  renderFooterBlock: PropTypes.func,
  userAnswer: PropTypes.string,
};

QuestionView.defaultProps = {
  question: {},
  onAnswer: () => {},
  readOnly: false,
};

export default withTranslation('exams')(QuestionView);
